
// src/store/authStore.js
import {create} from 'zustand';
import { authService } from '../api/services/auth';

const useAuthStore = create((set, get) => ({
    user: null,
    loading: false,
    error: null,

    login: async (credentials) => {
        set({ loading: true, error: null });
        try {
            const { data } = await authService.login(credentials);

            localStorage.setItem('token', data.token);
            //localStorage.setItem('refreshToken', data.refreshToken);
            set({ user: data.user, loading: false });
            return data;
        } catch (error) {
            set({ error: error.response?.data?.message || 'Přihlášení selhalo', loading: false });
            throw error;
        }
    },

    register: async (userData) => {
        set({ loading: true, error: null });
        try {
            const { data } = await authService.register(userData);
            set({ loading: false });
            return data;
        } catch (error) {
            set({ error: error.response?.data?.message || 'Registrace selhala', loading: false });
            throw error;
        }
    },

    logout: () => {
        authService.logout();
        set({ user: null });
    },

    fetchUser: async () => {
        const currentUser = get().user;

        // Pokud je uživatel již načtený, nic neděláme
        if (currentUser !== null && currentUser !== undefined) {
            return;
        }
        if ( get().loading === true ) {
            return;
        }

        set({ loading: true });
        try {
            const { data } = await authService.getCurrentUser();
            console.log(data);
            set({ user: data, loading: false });
        } catch (error) {
            set({ user: null, loading: false });
        }
    },
}));

export default useAuthStore;